export const FB_PIXEL_ID = "1455349618098149";

export function facebookPixel(event, type, payload) {
  try {
    if (process.env.NEXT_PUBLIC_ENVIRONMENT === "production") {
      //@ts-ignore
      fbq(event, type, payload);
    } else {
      console.log("[facebook-tracking]: event", event, type, payload);
    }
  } catch (err) {
    console.log("[facebook-tracking]: error", event, type, payload);
  }
}
